import React, { useEffect, useState, useContext, useRef } from 'react';
import { Card, CardBody, Col, Row } from "reactstrap";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { endpoint, pages } from '../../../../common/constant';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { successToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { failureToast } from 'views/pages/manage/common/utils/methods/toasterFunctions/function';
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { PermissionContext, RolePermissions } from "../../../../../../../appContext";
import { checkPermission, fetchAllPromisedData } from "../../../../common/utils/methods/commonMethods/utilityMethod";
import { PermisionDenied } from "../../../../common/commonComponents";
import { DisplayViewData, getAuditDetails } from '../common';
import { saveOrDeleteMsg } from 'views/pages/manage/edpOps/stockManagement/mastersAndMapping/sapProfitCostCentreMapping/constant';
import { sapDetail, tabFilledHandler } from '../constant';
import { getLatestUpdateInfo, getReqObj, initialForm } from './constant';
import SapLogsListing from './SapLogsListing';
import ALoader from 'views/pages/manage/common/a-loader';

var _ = require('lodash');

const grievanceLevels = ["L1", "L2", "L3"];

const weekdays = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" }
];

const ThirdPartyMapping = ({
    selectedTabValue,
    buId,
    action,
    isEdit,
    setIsEdit,
    setFilled,
    fetchBusinessAreaDetails
}) => {




    const permissions = useContext(PermissionContext);
    const userPermissions = RolePermissions(permissions, pages['businessAreaContactDetails']['id']);
    const isUpdatePermission = checkPermission(userPermissions, 'U');
    const isCreatePermission = checkPermission(userPermissions, 'C');
    const [loader, setLoader] = useState(false)

    const [form, setForm] = useState(initialForm);
    const [rows, setRows] = useState([])
    const [prevData, setPrevData] = useState({})
    const isFirstRender = useRef(true);


    // useEffect(() => {
    //     buId && selectedTabValue?.key=='sapDetail'&& getDetails()
    // }, [buId, selectedTabValue?.key])

      useEffect(() => {
         if (isFirstRender.current) {
           isFirstRender.current = false;
           if (buId) getDetails(); 
           return;
         }
         if (buId && selectedTabValue?.key === "sapDetail") {
           getDetails();
         }
       }, [buId, selectedTabValue?.key]);

    const checkFilled = (data) => {
        if (data?.sapPlantId) {
            tabFilledHandler(setFilled, 'sapDetail', true)
        }
        else {
            tabFilledHandler(setFilled, 'sapDetail', false)
        }
    }
    const getDetails = async () => {
        try {
            setLoader(true)
            const url1 = `${endpoint.businessArea.getBusinessAreaByIdV2}/${buId}`
            const url2 = `${endpoint.businessArea.getThirdPartyStatusByBusinessAreaId}/${buId}`
            const data = await Promise.all([fetchAllPromisedData(url1), fetchAllPromisedData(url2)])
            setForm(data[0]);
            setRows((data[1]?.thirdPartyList ?? []).map((item, index) => ({ ...item, srNo: index + 1 })))
            action == 'edit' && checkFilled(data[0])
        }
        catch (err) {
            console.error(err)
        }
        finally {
            setLoader(false)
        }
    }
    const editHandler = () => {
        if (isEdit) {
            failureToast(saveOrDeleteMsg)
        }
        else {
            setIsEdit(true)
            setPrevData(form)
        }
    }
    const cancelHandler = () => {
        setForm(prevData)
        setIsEdit(false)
    }

    if (selectedTabValue?.id != 4) return null;

    //     const allMandatoryFieldsEntered = () => {

    //   const hasEmptyField = (field) => !(_.isObject(field) ? !!field?.value?.trim() : !!field?.trim());
    //     const topLevelMandatoryFields = ['sapPlantId', 'sapBusinessArea', 'sapDescription', 'businessPlaceCode', 'defermentBusinessArea', 'gstInNumber'];
    //      if (topLevelMandatoryFields.some(field => (hasEmptyField(form[field])))) {
    //         return false;
    //     }
    //     }

    const saveHandler = async () => {
        if (form.sapPlantId && form.sapPlantId?.length < 4) {
            failureToast('Please Enter Valid SAP plant ID');
            return
        } else if (form.sapBusinessArea && form.sapBusinessArea?.length < 4) {
            failureToast('Please Enter Valid SAP Business Area');
            return
        } else if (form.businessPlaceCode && form.businessPlaceCode?.length < 4) {
            failureToast('Please Enter Valid Business place code');
            return
        } else if (form.defermentBusinessArea && form.defermentBusinessArea?.length < 4) {
            failureToast('Please Enter Valid Deferment business area');
            return
        }
        try {
            setLoader(true)
            const req = getReqObj({ ...form, buId })
            const url = endpoint.businessArea.syncSAPDetailsWithBusinessArea
            const data = await fetchAllPostPromisedData(url, req)
            if (data?.code == 200) {
                successToast(data?.message)
                action != 'new' && setIsEdit(false)
                action != 'new' && await getDetails()
                action == 'new' && tabFilledHandler(setFilled, 'sapDetail', true)
                fetchBusinessAreaDetails()
            }
        }
        catch (err) {
            console.log(err)
        }
        finally {
            setLoader(false)
        }
    }
const latestDate= getLatestUpdateInfo(rows&&rows?.length>0?rows[0]:null,form?.sapPlantId && form)
    return (

        userPermissions ?


            <>

                {loader && <ALoader position='fixed' />}
                <Card className='ml-0'>
                    <CardBody>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className='large-text color-grey-80'>Third party mapping</div>
                            {action != 'view' ? action == 'new' ?
                                <AButton
                                    variant="primary_filled"
                                    onClick={e => {
                                        e.stopPropagation();
                                        saveHandler();
                                    }}
                                    disabled={(action === 'new' && !isCreatePermission)}
                                >
                                    Save
                                </AButton>
                                :
                                (!isEdit) ? <AButton
                                    variant="outline"
                                    // className="w-full"
                                    onClick={() => {
                                        editHandler()
                                    }}
                                    disabled={!isUpdatePermission}
                                //    size='xs'
                                >
                                    Edit
                                </AButton>
                                    : <div> <AButton
                                        variant="primary_filled"
                                        // className="w-full"
                                        onClick={saveHandler}
                                        disabled={(action === 'new' && !isCreatePermission)}
                                    >
                                        Save changes
                                    </AButton>
                                        <AButton
                                            variant="danger_filled"
                                            // className="w-full"
                                            onClick={() => {
                                                cancelHandler()
                                            }}
                                            disabled={''}
                                        >
                                            Cancel
                                        </AButton>
                                    </div>
                                : <></>}
                        </div>
                        <div className='mt-24 mx-0' style={{ borderBottom: " 1px solid #E2E2E2" }}></div>

                        <DisplayViewData
                            dataArray={
                                sapDetail ?? []}
                            heading='Plant mapping'
                            isEdit={isEdit || action == 'new'}
                            action={action}
                            rowFormHandler={(key, val) => {
                                setForm({
                                    ...form,
                                    [key]: val
                                })
                            }}
                            form={form}
                            setForm={setForm}
                        //dropdown={geoData}
                        />
                        <div className='mt-24 mx-0' style={{ border: '1px solid #E2E2E2' }}>
                            <SapLogsListing
                                rows={rows}
                            />
                        </div>
                        {latestDate&&getAuditDetails(latestDate.updatedBy,latestDate.updatedOn)}
                    </CardBody>
                </Card>
            </>

            : <PermisionDenied />

    );
}

export default ThirdPartyMapping;